
    import {computed, defineComponent} from 'vue';
    import {getPageLocale} from '@malt/dom';
    import {useGlobalProperties} from '@malt/vue3-use';
    import {requireMessage} from '@malt/i18n';
    import FreelancerPriceDetails from '@/project-proposal/common/ui/FreelancerPriceDetails.vue';
    import {SelectedFreelancerResource} from '@/project-proposal/freelancer-selection/SelectedFreelancerResource';

    requireMessage('project.submission.header.price.label.*');

    export default defineComponent({
        name: 'FreelancerPrice',
        components: {
            FreelancerPriceDetails,
        },
        props: {
            profile: {
                type: SelectedFreelancerResource,
                required: true,
            },
            withTooltips: {
                type: Boolean,
                default: false,
            },
        },
        setup(props) {
            const {$msg} = useGlobalProperties();
            const priceLabel = computed<string>(() => {
                const price = props.profile.price;

                if (!price) {
                    return '';
                }

                const formattedPrice = new Intl.NumberFormat(getPageLocale(), {
                    style: 'currency',
                    currency: price.currencyCode || 'EUR',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                }).format(price.ht);

                return $msg(`project.submission.header.price.label.DAILY`, formattedPrice);
            });

            return {
                priceLabel,
            };
        },
    });
